module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.errorShow) ? _c('div', [_c('div', {
    staticClass: "networkError-frame"
  }, [_c('div', {
    staticClass: "network-center"
  }, [_c('span', {
    staticClass: "networkError-img"
  }), _vm._v(" "), _c('p', {
    staticClass: "network-p1",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "network-p2",
    domProps: {
      "textContent": _vm._s(_vm.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "network-btn",
    on: {
      "click": _vm.retry
    }
  }, [_c('p', {
    domProps: {
      "textContent": _vm._s(_vm.btnContent)
    }
  })])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-1689cbe2!./~/_vux-loader@1.1.30@vux-loader/src/template-loader.js!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/netError.vue
// module id = 338
// module chunks = 15